import React, { useEffect, useState } from "react";
import styles from "./FAQSection.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { getFAQs } from "services/FAQ/get-FAQs";
import { getCost } from "services/cost/get-cost";

export default function FAQSection() {
  const [faqData, setFaqData] = useState<{ id: string; question: string; answer: string; is_active: boolean }[]>([]);
  const [costData, setCostData] = useState<{ id: string; category: string; price: number; }[]>([]);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const fetchData = async () => {
    try {
      const faqs = await getFAQs();
      const costs = await getCost();
      const activeFAQs = faqs.filter((faq: { is_active: string }) => Boolean(faq.is_active));
      
      const answer = `Die Kosten der Flexi-Buchung, die sich auf einen Block/Doppelstunde (= 120 Minuten) und pro Kind beziehen, betragen: 
      <ul>
        ${costs.map((cost: { category: string; price: number }) => 
          cost.price != null ? `<li>für ${cost.category}: ${cost.price.toFixed(2)} €</li>` : ''
        ).join('')}
      </ul>
      Bitte beachten: Deine Buchungsanfragen müssen 24 Stunden vor der Betreuung erfolgen.`;
      

      activeFAQs.push({
        id: '0',
        question: 'Wie teuer ist die Buchung?',
        answer: answer,
        is_active: true
      });

      setFaqData(activeFAQs);
      setCostData(costs);
    } catch (error) {
      console.error("Fehler beim Laden der Daten:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className={`${commonStyles.sectionContainer} ${styles.container}`}>
      <div className={`${commonStyles.sectionTitle} ${styles.faqTitle}`}>
        <h1>FAQ</h1>
        <div className={`${commonStyles.sectionBorderBottom} ${styles.borderBottom}`} />
      </div>

      {faqData.map((item, index) => (
        <div key={item.id} className={styles.faqItem}>
          <div className={styles.faqQuestion} onClick={() => handleToggle(index)}>
            <p>{item.question}</p>
            <span className={`${styles.toggleIcon} ${activeIndex === index ? styles.active : styles.inactive}`}>
              {activeIndex === index ? "_" : "+"}
            </span>
          </div>

          <div className={`${styles.faqAnswer} ${activeIndex === index ? styles.active : ""}`} dangerouslySetInnerHTML={{ __html: item.answer }} />
          
          <hr />
        </div>
      ))}
    </div>
  );
}
